import { CardTag } from "@homebound/beam";
import { MaterialVariant } from "src/generated/graphqlTypes";

type ReplacementTagOpts = Pick<MaterialVariant, "matchesPlaceholder" | "hasAwardedCost"> & {
  /** Whether the product was defined for this swap, i.e. it wasn't picked out of the catalog. */
  wasCreated?: boolean;
};
/** How ready a replacement product is to swap in, as a `Card` tag */
export function replacementTag(opts: ReplacementTagOpts): { tag: CardTag; tooltip?: string } {
  const { matchesPlaceholder, hasAwardedCost, wasCreated = false } = opts;
  if (wasCreated) {
    return { tag: { text: "CUSTOM", type: "info" } };
  } else if (!matchesPlaceholder) {
    return { tag: { text: "OTHER SLOT", type: "error" } };
  } else if (!hasAwardedCost) {
    return { tag: { text: "NO COST", type: "error" }, tooltip: "There is no cost for this product in this market." };
  }
  return { tag: { text: "READY TO SWAP", type: "success" } };
}
